import { useEffect, useState } from "react";
import RedirectBTN from "../components/RedirectBTN";
import { LoginButton } from "../components/LoginButton";
import { UserLoginState } from "../util/userLoginState";
import { ValidateAccountCallback } from "../util/ValidateAccountCallback";
import { PasswordFields } from "../components/PasswordFields";
import { useTheme } from "../../../context/useThemeContext";
import useAccountManagementStore, {
    userDataType,
} from "../../../stores/accountManagementStore";
import { useAccountManagementFunctions } from "../hooks/useAccountManagementFunctions";
import { useFormCooldown } from "../hooks/useFormCooldown";

export default function ResetPassword() {
    const { theme } = useTheme();
    const userLoginState = UserLoginState();
    const { setLoginState } = useAccountManagementStore(
        (state) => state
    );
    const { updatePassword } = useAccountManagementFunctions();
    const { canSubmit, startCooldown } = useFormCooldown(1);

    useEffect(() => {
        userLoginState.setEmail("dummy@gmail.com");
    }, []);

    async function submitPasswordChange() {
        if (!canSubmit) return;

        const access_token = new URLSearchParams(window.location.hash).get(
            "#access_token",
        );
        const refresh_token = new URLSearchParams(window.location.hash).get(
            "refresh_token",
        );

        try {
            const result = await updatePassword(
                userLoginState.password
            );

            if (result === "same_password") {
                userLoginState.setPasswordErrorMessage(
                    "New password has not changed",
                );
                return;
            } else if (result === null) {
                userLoginState.setVerifyPasswordErrorMessage(
                    "An Error Occurred",
                );
                startCooldown();
            } else {
                setLoginState("checkEmail_ResetPassword");
            }
        } catch (error) {
            console.error("Failed to reset password:", error);
            userLoginState.setVerifyPasswordErrorMessage("An Error Occurred");
            startCooldown();
        }
    }

    return (
        <div className="updateAccountForm flex flex-col p-9 pb-7 text-center text-white">
            <b className="mb-3 flex content-center justify-center text-2xl">
                Reset Password
            </b>
            <form
                className="flex flex-col"
                onSubmit={(e) => {
                    ValidateAccountCallback(
                        userLoginState.setEmailErrorMessage,
                        userLoginState.setPasswordErrorMessage,
                        userLoginState.setVerifyPasswordErrorMessage,
                        userLoginState.email,
                        userLoginState.password,
                        userLoginState.confirmPassword,
                        submitPasswordChange,
                    );
                    e.preventDefault();
                }}
            >
                <PasswordFields
                    confirmPassword={userLoginState.confirmPassword}
                    password={userLoginState.password}
                    passwordErrorMessage={userLoginState.passwordErrorMessage}
                    setConfirmPassword={userLoginState.setConfirmPassword}
                    setPassword={userLoginState.setPassword}
                    verifyPasswordErrorMessage={
                        userLoginState.verifyPasswordErrorMessage
                    }
                />
                <div className="mb-1 flex w-full space-x-2 self-center text-sm">
                    <RedirectBTN
                        name="Cancel"
                        onClick={() => {
                            setLoginState("default");
                        }}
                    />
                </div>
                <LoginButton
                    type="submit"
                    className="my-4 h-[36px] rounded text-sm"
                    disabled={!canSubmit}
                    style={{
                        backgroundColor: theme.accentColor,
                        opacity: canSubmit ? 1 : 0.5,
                        cursor: canSubmit ? "pointer" : "not-allowed",
                    }}
                >
                    Confirm
                </LoginButton>
            </form>
        </div>
    );
}
